import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs"

import { SubscriptionsCreateRecurrenceForm } from "./form"
export const SubscriptionsCreateRecurrenceTabs = () => {
  return (
    <Tabs defaultValue="details">
      <TabsList>
        <TabsTrigger value="details">Detalhes</TabsTrigger>
        <TabsTrigger value="products">Produtos</TabsTrigger>
      </TabsList>
      <TabsContent value="details">
        <Card>
          <CardHeader>
            <CardTitle>Detalhes da recorrência</CardTitle>
          </CardHeader>
          <CardContent>
            <SubscriptionsCreateRecurrenceForm />
          </CardContent>
        </Card>
      </TabsContent>
      <TabsContent value="products">Produtos</TabsContent>
    </Tabs>
  )
}
